<template>
    <div class="flex items-center justify-center w-full">
        <div class="w-full flex flex-col items-center justify-center">
            <audio
            id="audio"
            ref="audio"
            controls
            class="hidden"
            :poster="episode.podcast.image"
            :title="episode.title"
            >
            </audio>

            <div v-if="loading">⏳</div>
            <div v-if="!loading" class="flex max-w-md w-full justify-center space-x-10 items-center mb-4">
                <div @click="toggleSpeed" class="w-12 text-base font-medium flex items-center justify-center text-xl space-x-0.5 text-gray-700 cursor-pointer hover:text-regal-blue-700 transition-colors duration-100 ease-out">
                    <div class="">
                        {{ playbackRate }}
                    </div>
                    <div class="">
                        ✗
                    </div>
                </div>
                <div @click="seekBackward" class="flex items-start font-medium text-xl text-gray-700 cursor-pointer hover:text-regal-blue-700 transition-colors duration-100 ease-out">
                    ↺<span class="text-xs">15</span>
                </div>

                <div @click="play" v-if="!playing" class="shrink-0 flex items-center justify-center text-white w-16 h-16 bg-regal-blue-700 rounded-full hover:bg-regal-blue-800 transition duration-100 ease-out cursor-pointer">
                    <svg class="fill-current w-7 h-7 -mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M3 22v-20l18 10-18 10z"/></svg>
                </div>
                <div @click="pause" v-if="playing" class="shrink-0 flex items-center justify-center text-white w-16 h-16 bg-regal-blue-700 rounded-full hover:bg-regal-blue-800 transition-colors duration-100 ease-in cursor-pointer">
                    <svg class="fill-current w-12 h-12" viewBox="0 0 512 512"> <g> </g> <path d="M162.642 148.337h56.034v215.317h-56.034v-215.316z"/> <path d="M293.356 148.337h56.002v215.317h-56.002v-215.316z" /></svg>
                </div>

                <div @click="seekForward" class="flex items-start font-medium text-xl text-gray-700 cursor-pointer hover:text-regal-blue-700 transition-colors duration-100 ease-out">
                    ↻<span class="text-xs">15</span>
                </div>

                <div class="w-12 text-base font-medium flex items-center justify-center text-xl space-x-0.5 text-gray-700 cursor-pointer hover:text-regal-blue-700 transition-colors duration-100 ease-out">

                </div>

            </div>

            <div class="w-full max-w-screen-md">
                <div class="w-full relative h-20 cursor-pointer" @click="seek">
                        <div class="backdrop-saturate-0 absolute z-20 h-24" :style="'width:' + progressWidth + '%; left:' + progressLeft + '%'"/>
                        <div class="absolute bg-left bg-repeat-x bg-contain h-24 w-full z-10" :style="'background-image: url(' + asset('img/sound-waves.svg') + ')'" />
                </div>
                <div class="w-full flex justify-between text-xs font-medium text-gray-800 tracking-tight tabular-nums">
                    <div class="">
                        {{ formattedTime.currentTime }}
                    </div>
                    <div class="">
                        {{ formattedTime.remaining }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import computed from 'vue'
import usePage from '@inertiajs/inertia-vue3'
import Hls from 'hls.js'
import { ref } from 'vue'
import axios from 'axios'

export default {
    setup(props) {
        const timestamps = ref({
            duration: props.episode.duration,
            currentTime: 0,
        })
        const audio = ref(null)
        const src = props.episode.audio.manifest
        const loading = ref(true)
        const hls = ref(null)
        const startPosition = ref(-1)
        const progress = ref(0)
        const progressLeft = ref(0)
        const progressWidth = ref(100)
        const playing = ref(false)
        const playbackRate = ref(1)
        const ping = ref(0)
        const currentSec = ref(null)
        const lastSec = ref(null)
        const trackerArray = ref([])

        return { timestamps, audio, src, loading, hls, startPosition, progress, progressLeft, progressWidth, playing, playbackRate, ping, currentSec, lastSec, trackerArray }
    },
    props: {
        episode: Object,
        // duration: String,
        // currentTime: [Number, Boolean],
        // played: Boolean,
    },
    mounted() {
        if (this.episode.audio.manifest) {
            this.audio = this.$refs.audio
            let config = {
                debug: false,
                autoStartLoad: false,
                // maxMaxBufferLength: 1,
                xhrSetup: function (xhr,url) {
                    xhr.withCredentials = true // do send cookie
                    // xhr.setRequestHeader('Access-Control-Allow-Headers', 'Content-Type, Accept, X-Requested-With')
                    // xhr.setRequestHeader('Access-Control-Allow-Origin', appUrl)
                    // xhr.setRequestHeader('Access-Control-Allow-Credentials', 'true')
                }
            }
            if (this.audio.canPlayType('application/vnd.apple.mpegurl')) {
                this.audio.src = this.src
                this.loading = false
            } else if (Hls.isSupported()) {
                this.hls = new Hls(config)
                this.hls.loadSource(this.src)
                this.hls.attachMedia(this.audio)
                this.hls.on(Hls.Events.MANIFEST_PARSED, (event, data) => {
                    this.loading = false
                    // console.log(event, data)
                    // console.log(this.audio.duration);
                })
            }
            this.audio.onloadedmetadata = (event) => {
                this.timestamps.duration = this.audio.duration
                // this.loading = false
            }
            this.audio.ontimeupdate = (event) => {
                this.timestamps.currentTime = this.audio.currentTime
                this.progressLeft = (this.audio.currentTime / this.audio.duration) * 100 || 0
                this.progressWidth = 100 - this.progressLeft
                // if (Math.round(this.audio.currentTime) !== this.ping) {
                //     this.ping = Math.round(this.audio.currentTime)
                // }
                this.currentSec = Math.round(this.audio.currentTime)
                if (this.currentSec !== this.lastSec) {
                    if (this.currentSec !== this.trackerArray[this.trackerArray.length - 1]) {
                        this.trackerArray.push(this.currentSec)
                        if (this.trackerArray.length === 5) {
                            emit('ping', this.trackerArray)
                            this.trackerArray = []
                        }
                    }
                }
                this.lastSec = Math.round(this.audio.currentTime)
            }
            this.audio.onseeking = (event) => {
            }
            this.audio.onseeked = (event) => {
            }
            this.audio.onpause = (event) => {
                this.playing = false
            }
            this.audio.onplaying = (event) => {
                this.playing = true
            }
            this.audio.onended = (event) => {
                this.playing = false
            }

            if (this.episode.currentTime && !this.episode.played) {
                this.audio.currentTime = this.episode.currentTime
                this.progressLeft =  this.episode.currentTime / this.episode.duration * 100
                this.progressWidth = 100 - this.progressLeft
                this.timestamps.currentTime = this.episode.currentTime
            }
        }
    },
    // watch: {
    //     ping() {
    //         this.$emit('ping', this.ping)
    //     }
    // },
    methods: {
        play(currentTime) {
            if (this.audio.canPlayType('application/vnd.apple.mpegurl')) {
            } else if (Hls.isSupported()) {
                this.hls.startLoad(this.startPosition)
            }
            let playPromise = this.audio.play()
            if (currentTime && Number.isInteger(currentTime)) {
                this.audio.currentTime = currentTime
            }

            playPromise
                .then(() => {
                    // console.log(currentTime)
                    if (currentTime && Number.isInteger(currentTime)) {
                        this.audio.currentTime = currentTime
                    }

                    // this.playing = true
                })
                .catch((error) => {
                    // this.playing = false
                })
            // if (playPromise !== undefined) {
            //     playPromise.then((e) => {
            //         console.log('playing')
            //         this.playing = true
            //     }).catch((error) => {
            //         this.playing = false
            //         // console.log(error)
            //     })
            // }
        },
        pause() {
            if (!this.audio.paused) {
                this.audio.pause()
                this.playing = false
            }
        },
        seek(e) {
            var pos = (e.clientX - e.currentTarget.getBoundingClientRect().left) / e.currentTarget.getBoundingClientRect().width
            var seek = parseInt(this.episode.duration) * pos
            if (this.playing) {
                this.audio.currentTime = seek
            } else {
                this.play(seek)
            }
        },
        seekForward() {
            this.audio.currentTime = this.audio.currentTime + 15
            this.progressLeft =  this.progress + (this.episode.duration*15/100)
            this.progressWidth = 100 - this.progressLeft
            this.timestamps.currentTime = this.audio.currentTime
        },
        seekBackward() {
            this.audio.currentTime = this.audio.currentTime - 15
            this.progressLeft =  this.progress + (this.episode.duration*15/100)
            this.progressWidth = 100 - this.progressLeft
            this.timestamps.currentTime = this.audio.currentTime
        },
        toggleSpeed() {
            const playbackRates = [.5, .8, 1, 1.2, 1.5, 2, 3];
            const getCurrentSpeed = (element) => element === this.audio.playbackRate;
            const index = playbackRates.findIndex(getCurrentSpeed) == playbackRates.length - 1 ? 0 : playbackRates.findIndex(getCurrentSpeed) + 1;
            this.playbackRate = this.audio.playbackRate = playbackRates[index];
        },
    },
    computed: {
        // playedWaves() {
        //     return Math.round(this.progress)
        // },
        // remainingWaves() {
        //     return 100 - this.episode.playedWaves
        // },
        formattedTime() {
            return {
                duration: this.formatTime(Math.round(this.timestamps.duration)),
                currentTime: this.formatTime(Math.round(this.timestamps.currentTime)),
                remaining: '–' + this.formatTime(Math.round(this.timestamps.duration) - Math.round(this.timestamps.currentTime)),
            }
        },
    }
}
</script>
